import { BaseModel } from 'AppModels/base'

export class FirebaseResult extends BaseModel {
  data: any
  constructor(data?: any) {
    super(true)
    this.data = data
  }
}